import { PuzzleFrameworkConfigModel } from 'projects/tools/src/lib/store/puzzle-framework-config.model';

export class UpdateFrameworkConfig {
  static readonly type = '[PuzzleFrameworkConfig] Set config';
  constructor(public payload: { puzzleFrameworkConfig: PuzzleFrameworkConfigModel }) {}
}
